module.exports = __webpack_public_path__ + "media/images/pages/ai/pocstock-ethical-ai-face-13@2x-4e74350d08da1d670b3ab467809f28bf.png";